import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { UserListComponent } from './user-list/user-list.component';
import { MbscModule } from '@mobiscroll/angular';
import { NgbDropdownModule, NgbModalModule, NgbPaginationModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { LocalDatePipe } from '../core/pipes.model';
import { FormsModule } from '@angular/forms';
import { DeleteUserComponent } from './delete-user/delete-user.component';
import { MustEqualDirective } from '../core/validators.model';
import { DirtyTrackingDirective } from '../core/dirty-tracking/dirty-tracking.directive';
import { AppModule } from '../app.module';
import { CoreModule } from '../core/core.module';
import { ViewUserAssignmentListComponent } from './view-user-assignment-list/view-user-assignment-list.component';
import { ViewUserAssignmentComponent } from './view-user-assignment/view-user-assignment.component';
import { MessageUsersComponent } from './message-users/message-users.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SyncFavoritesComponent } from './sync-favorites/sync-favorites.component';

@NgModule({
  declarations: [
    UserListComponent,
    DeleteUserComponent,
    ViewUserAssignmentListComponent,
    ViewUserAssignmentComponent,
    MessageUsersComponent,
    SyncFavoritesComponent,
  ],
  imports: [
    MbscModule,
    CommonModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbModalModule,
    NgbPopoverModule,
    FormsModule,
    CoreModule,
    CKEditorModule,
  ],
  exports: [
  ],
  providers: [
    DatePipe
  ]
})
export class UsersModule { }
